import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Button, Header, Form, Grid, Image, Container} from 'semantic-ui-react';
import CustomDivider from '../../components/extras/CustomDivider';

import auth from "../../data/auth";
import Toast from "../../components/extras/Toast";
import {connect} from "react-redux";
import {showToast} from "../../actions/ToastAction";
import update from "react-addons-update";
import localDB from "../../data/localDB";
import LocalData from "../../data/LocalData";

const logo = require('../../img/logo_text.svg');

class ResetPasswordConfirm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: {
                uid:  this.props.match.params.uid,
                token: this.props.match.params.token,
                password:{
                    new_password: '',
                    re_new_password: ''
                }
            },
            new_password_error: false,
            re_new_password_error: false,
            loading: false
        };

        this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this);
        this.handleReNewPasswordChange = this.handleReNewPasswordChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        localDB.cleanSession();
    }

    handleNewPasswordChange(event) {
        if (event.target.value.trim() === '') {
            this.setState({new_password_error: true})
        } else {
            let new_password = update(this.state, {
                data: {
                    password: {
                        new_password: {
                            $set: event.target.value
                        }
                    }
                }
            });
            this.setState(new_password);
            this.setState({new_password_error: false, re_new_password_error:false});
        }
    }

    handleReNewPasswordChange(event) {
        if (event.target.value.trim() === '') {
            this.setState({re_new_password_error: true})
        } else {
            let re_new_password = update(this.state, {
                data: {
                    password: {
                        re_new_password: {
                            $set: event.target.value
                        }
                    }
                }
            });
            this.setState(re_new_password);
            this.setState({re_new_password_error: false, new_password_error:false});
        }
    }

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.data.password.new_password !== this.state.data.password.re_new_password) {
            this.props.showToast({message:'Las contraseñas no coinciden!', type:'error'});
            this.setState({re_new_password_error: true, new_password_error: true});
        } else {
            this.setState({loading: true});
            auth.resetPasswordConfirm(this.state.data, (res) => {
                if(res.hasOwnProperty('token')){
                    LocalData.products();
                    LocalData.clients();
                    LocalData.providers();
                    LocalData.ingredients();
                    this.props.history.push('/');
                    this.props.showToast({message:'Contraseña actualizada!', type:'success'});
                }else{
                    this.props.showToast({message:'Este enlace ha caducado!', type:'error'});
                }
                this.setState({loading: false, email:'', email_error:false});
            });
        }
    }

    render() {
        return (
            <div style={{minHeight: 'calc(100vh)', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Toast ref='toast'/>
                <Helmet>
                    <title>Quipuu</title>
                </Helmet>
                <Grid>
                    <Grid.Row columns={2} centered>
                        <Grid.Column mobile={16} tablet={8} computer={7} largeScreen={6} widescreen={6}>
                            <Container>
                                <Header as='h1' textAlign='center'>
                                    <Header.Content>
                                        Restaurar tu Contraseña
                                    </Header.Content>
                                    <Header.Subheader>
                                        Ingresa una nueva contraseña para tu cuenta
                                    </Header.Subheader>
                                </Header>
                                <Form onSubmit={this.handleSubmit}>
                                    <Form.Field>
                                        <Form.Input
                                            placeholder='Contraseña nueva'
                                            value={this.state.data.password.new_password}
                                            type='password'
                                            onChange={this.handleNewPasswordChange}
                                            autoComplete="new-password"
                                            error={this.state.new_password_error}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <Form.Input
                                            placeholder='Vuelve a escribir la contraseña'
                                            type='password'
                                            value={this.state.data.password.re_new_password}
                                            autoComplete="re-password"
                                            onChange={this.handleReNewPasswordChange}
                                            error={this.state.re_new_password_error}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <Button fluid type="submit" primary disabled={this.state.loading}
                                                loading={this.state.loading}>Restaurar</Button>
                                    </Form.Field>
                                </Form>
                                <CustomDivider/>
                                <Image centered src={logo} alt="Quipuu" size='small'/>
                            </Container>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        showToast(data){
            dispatch(showToast(data))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(ResetPasswordConfirm)


// WEBPACK FOOTER //
// ./src/containers/main/ResetPasswordConfirm.js